import Bugsnag from '@bugsnag/js'
import { redirectToLogin } from '../auth'

function RequestHeaderBuilder() {
  const DEFAULT_REQUEST_HEADER = {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'application-token': process.env.REACT_APP_TOKEN
  }

  function decorate(customRequestHeader = {}) {
    return { ...DEFAULT_REQUEST_HEADER, ...customRequestHeader }
  }
  return {
    buildHeader(headers) {
      return decorate(headers)
    }
  }
}

function RequestBuilder() {
  const { REACT_APP_FUSION_ORIGIN } = process.env

  function normalizePath(path) {
    if (path.startsWith('/')) return path.slice(1)

    return path
  }

  function buildUrl(path) {
    return `${REACT_APP_FUSION_ORIGIN}/${normalizePath(path)}`
  }

  function buildBody(payload) {
    if (!payload) {
      return {}
    }

    return {
      body: JSON.stringify(payload)
    }
  }

  function fetchWithAuthCheck(url, options) {
    return fetch(url, options)
      .then((response) => {
        if (response.status === 401) {
          redirectToLogin()
          return Promise.reject(new Error('Unauthorized'))
        }
        return response
      })
      .catch((error) => {
        Bugsnag.notify(error)
        Promise.reject(error)
      })
  }

  function build(path, method, payload, headers) {
    let options = {
      method,
      headers,
      mode: 'cors'
    }

    if (method !== 'GET') {
      options = { ...options, ...buildBody(payload) }
    }

    return fetchWithAuthCheck(buildUrl(path), options)
  }

  return {
    get(path, payload, headers) {
      return build(path, 'GET', payload, headers)
    },

    post(path, payload, headers) {
      return build(path, 'POST', payload, headers)
    },

    patch(path, payload, headers) {
      return build(path, 'PATCH', payload, headers)
    },

    delete(path, payload, headers) {
      return build(path, 'DELETE', payload, headers)
    }
  }
}

export default { ...RequestHeaderBuilder(), ...RequestBuilder() }
